<section class="userDetailed w-full max-w-6xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <ng-container *ngIf="userDetailes$ | async as currentUserView; else loadingState">

    <!-- Hero: user identity + balance + key stats -->
    <header class="card-2026 card-2026--elevated flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-gradient-to-bl from-primary-50 to-surface">
      <div>
        <p class="text-base text-ink-500">פרטי מתפלל</p>
        <h1 class="text-3xl md:text-4xl font-bold text-primary-700 mt-1">
          {{ currentUserView.firstName }} {{ currentUserView.lastName }}
        </h1>
        <p class="text-sm text-ink-500 mt-1" *ngIf="currentUserView.email">{{ currentUserView.email }}</p>
      </div>

      <div class="grid grid-cols-2 gap-3 md:gap-6 md:min-w-[320px]">
        <div class="text-center md:text-start">
          <div class="text-sm text-ink-500 font-medium">סה"כ הזמנות</div>
          <div class="text-2xl font-bold text-ink-800 mt-1">{{ currentUserView.orders.length }}</div>
        </div>
        <div class="text-center md:text-start">
          <div class="text-sm text-ink-500 font-medium">יתרה</div>
          <div class="text-2xl font-bold mt-1 money"
               [class.money--credit]="currentUserView.balance > 0"
               [class.money--debt]="currentUserView.balance < 0"
               [class.money--zero]="currentUserView.balance === 0">
            {{ currentUserView.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
          </div>
        </div>
      </div>
    </header>

    <!-- Quick actions -->
    <div class="quick-actions flex flex-col md:flex-row gap-3 flex-wrap">
      <a
        [routerLink]="['/prayers/order/add']"
        [queryParams]="{ userId: currentUserView._id }"
        class="btn-2026--primary w-full md:w-auto"
      >
        <span class="material-symbols-outlined" aria-hidden="true">add_circle</span>
        הזמנה חדשה למתפלל
      </a>

      <button
        *ngIf="userHasAccess"
        type="button"
        class="btn-2026--ghost w-full md:w-auto"
        (click)="openAdjustDialog()"
      >
        <span class="material-symbols-outlined" aria-hidden="true">tune</span>
        התאם יתרה ידנית
      </button>

      <button
        type="button"
        class="btn-2026--ghost w-full md:w-auto"
        (click)="onPrint()"
      >
        <span class="material-symbols-outlined" aria-hidden="true">print</span>
        הדפס היסטוריה
      </button>

      <button
        type="button"
        class="btn-2026--ghost w-full md:w-auto"
        (click)="downloadFullHistoryPdf()"
        [disabled]="fullPdfBusy || allSortedOrders.length === 0"
      >
        <span *ngIf="!fullPdfBusy" class="material-symbols-outlined" aria-hidden="true">picture_as_pdf</span>
        <span *ngIf="fullPdfBusy" class="material-symbols-outlined animate-spin" aria-hidden="true">progress_activity</span>
        {{ fullPdfBusy ? 'מכין PDF...' : 'הורד PDF - כל ההיסטוריה' }}
      </button>
    </div>

    <!-- ── Filters ──────────────────────────────────────────────── -->
    <div *ngIf="allSortedOrders.length > 0" class="filters-card card-2026 space-y-3">
      <div class="flex items-center justify-between gap-3 flex-wrap">
        <h2 class="text-lg font-semibold text-ink-800">סינון היסטוריית הזמנות</h2>
        <button
          *ngIf="hasFilters"
          type="button"
          (click)="resetFilters()"
          class="text-base text-primary-600 hover:underline font-medium flex items-center gap-1"
        >
          <i class="material-symbols-outlined text-lg" aria-hidden="true">close</i>
          נקה סינון
        </button>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <!-- Year -->
        <div class="form-row-2026">
          <label class="form-row-2026__label" for="filterYear">שנה</label>
          <select
            id="filterYear"
            class="input-2026"
            [value]="filterYear ?? ''"
            (change)="onYearChange($any($event.target).value)"
          >
            <option value="">כל השנים</option>
            <option *ngFor="let y of availableYears" [value]="y">{{ y }}</option>
          </select>
        </div>

        <!-- Month -->
        <div class="form-row-2026">
          <label class="form-row-2026__label" for="filterMonth">חודש</label>
          <select
            id="filterMonth"
            class="input-2026"
            [value]="filterMonth ?? ''"
            (change)="onMonthChange($any($event.target).value)"
          >
            <option value="">כל החודשים</option>
            <option *ngFor="let m of availableMonths" [value]="m.value">{{ m.label }}</option>
          </select>
        </div>

        <!-- Parasha -->
        <div class="form-row-2026">
          <label class="form-row-2026__label" for="filterParasha">פרשה</label>
          <select
            id="filterParasha"
            class="input-2026"
            [value]="filterParasha ?? ''"
            (change)="onParashaChange($any($event.target).value)"
          >
            <option value="">כל הפרשות</option>
            <option *ngFor="let p of availableParashot" [value]="p">{{ p }}</option>
          </select>
        </div>
      </div>

      <!-- Range info -->
      <div class="text-sm text-ink-500 pt-1 border-t border-ink-100">
        מציג <span class="font-semibold">{{ viewWindow }}</span>
        מתוך <span class="font-semibold">{{ filteredOrders.length }}</span> הזמנות
        <span *ngIf="filteredOrders.length !== allSortedOrders.length">
          (מתוך {{ allSortedOrders.length }} בסך הכל)
        </span>
        <span class="mx-2">·</span>
        עמוד <span class="font-semibold">{{ currentPage }}</span> מתוך
        <span class="font-semibold">{{ totalPages }}</span>
      </div>
    </div>

    <!-- ── Grouped tables (year/month sections) ───────────────────── -->
    <ng-container *ngIf="filteredOrders.length > 0; else noOrders">
      <div *ngFor="let yearGroup of groupedOrders" class="space-y-4">

        <!-- Year banner -->
        <h2 class="text-2xl font-bold text-primary-700 px-1 mt-2 first:mt-0 flex items-center gap-3">
          <span class="inline-block w-1.5 h-7 bg-accent-500 rounded-full"></span>
          {{ yearGroup.year }}
        </h2>

        <!-- Month sub-sections -->
        <div *ngFor="let monthGroup of yearGroup.months" class="space-y-2">
          <h3 class="text-lg font-semibold text-ink-700 px-1 flex items-center gap-2">
            {{ monthGroup.monthName }} {{ yearGroup.year }}
            <span class="text-sm text-ink-500 font-normal">({{ monthGroup.orders.length }})</span>
          </h3>

          <!-- ── Mobile card list (hidden md+) ────────────────────── -->
          <div class="md:hidden space-y-2">
            <ng-container *ngFor="let order of monthGroup.orders">

              <!-- Adjustment card (readonly, accent stripe) -->
              <div
                *ngIf="isAdjustment(order)"
                class="card-2026 !p-3 border-r-4 border-accent-500 bg-accent-50/60"
              >
                <div class="flex justify-between items-start gap-2">
                  <div class="flex items-center gap-2 text-accent-700 font-bold">
                    <i class="material-symbols-outlined" aria-hidden="true">tune</i>
                    <span>התאמת יתרה</span>
                  </div>
                  <span class="money font-bold text-lg"
                        [class.money--credit]="order.pricePaid > order.price"
                        [class.money--debt]="order.price > order.pricePaid">
                    {{ order.pricePaid > order.price ? '+' : '−' }}{{ (order.pricePaid > order.price ? order.pricePaid - order.price : order.price - order.pricePaid) | currency : 'ILS' : 'symbol' : '1.0-0' }}
                  </span>
                </div>
                <div class="mt-2 text-sm text-ink-600">
                  <span>{{ order.createdAt | date : 'd בMMM, HH:mm' : '' : 'he-IL' }}</span>
                  <span class="mx-1">·</span>
                  <span>ע"י <span class="font-semibold">{{ order.doneBy || 'אדמין' }}</span></span>
                </div>
                <p *ngIf="order.note" class="mt-1 text-sm text-ink-700 italic">
                  סיבה: {{ order.note }}
                </p>
                <p class="text-xs text-ink-500 italic mt-2">לקריאה בלבד</p>
              </div>

              <!-- Regular order card -->
              <a
                *ngIf="!isAdjustment(order)"
                [routerLink]="['/prayers/overall-table', userId, 'order', order._id]"
                class="card-2026 !p-3 block hover:bg-primary-50/40 transition-colors"
              >
                <!-- Header: parasha + remaining -->
                <div class="flex justify-between items-start gap-2">
                  <div>
                    <div class="font-bold text-ink-800 text-base">{{ order.parasha }}</div>
                    <div class="text-xs text-ink-500 mt-0.5">
                      {{ order.createdAt | date : 'd בMMM, HH:mm' : '' : 'he-IL' }}
                    </div>
                  </div>
                  <div class="text-end">
                    <ng-container *ngIf="order.pricePaid >= order.price; else mobileRemaining">
                      <span class="inline-flex items-center gap-1 text-success font-semibold text-sm">
                        <i class="material-symbols-outlined text-base" aria-hidden="true">check_circle</i>
                        שולם
                      </span>
                    </ng-container>
                    <ng-template #mobileRemaining>
                      <div class="text-xs text-ink-500">נותר</div>
                      <div class="money money--debt font-bold">
                        {{ order.price - order.pricePaid | currency : 'ILS' : 'symbol' : '1.0-0' }}
                      </div>
                    </ng-template>
                  </div>
                </div>

                <!-- Items pills -->
                <div *ngIf="order.name?.length" class="flex flex-wrap gap-1 mt-2">
                  <span *ngFor="let n of order.name"
                        class="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                    {{ n }}
                  </span>
                </div>

                <!-- Amounts row -->
                <div class="grid grid-cols-2 gap-2 mt-3 pt-2 border-t border-ink-100 text-sm">
                  <div>
                    <span class="text-ink-500">עלות:</span>
                    <span class="money font-semibold text-ink-800">
                      {{ order.price | currency : 'ILS' : 'symbol' : '1.0-0' }}
                    </span>
                  </div>
                  <div>
                    <span class="text-ink-500">שולם:</span>
                    <span class="money font-semibold text-ink-800">
                      {{ order.pricePaid | currency : 'ILS' : 'symbol' : '1.0-0' }}
                    </span>
                  </div>
                </div>

                <!-- Admin row: invoice + delete -->
                <div *ngIf="userHasAccess"
                     class="mt-3 pt-2 border-t border-ink-100 flex items-stretch gap-2"
                     (click)="$event.stopPropagation(); $event.preventDefault()">
                  <input
                    type="text"
                    [value]="order.orderInvoice || ''"
                    placeholder="מס' קבלה"
                    class="input-2026 text-sm flex-1 !min-h-[40px] !py-1.5 !px-2"
                    (input)="onInputChange($event, order._id)"
                    aria-label="מס' קבלה"
                  />
                  <button
                    *ngIf="showEditButton === order._id"
                    type="button"
                    class="btn-2026--primary !min-h-[40px] !py-1 !px-3"
                    (click)="saveInvoice(order._id)"
                    aria-label="שמור"
                  >
                    <i class="material-symbols-outlined" aria-hidden="true">save</i>
                  </button>
                  <button
                    type="button"
                    class="btn-2026--danger !min-h-[40px] !py-1 !px-3"
                    (click)="openDeleteModal(order._id)"
                    aria-label="מחק הזמנה"
                  >
                    <i class="material-symbols-outlined" aria-hidden="true">delete</i>
                  </button>
                </div>
              </a>
            </ng-container>
          </div>

          <!-- ── Tablet+ table (hidden < md) ──────────────────────── -->
          <div class="hidden md:block overflow-x-auto">
            <table class="table-2026 w-full">
              <thead>
                <tr>
                  <th>{{ dateLabel }}</th>
                  <th>{{ parahsa }}</th>
                  <th>{{ desc }}</th>
                  <th class="text-end">{{ amount }}</th>
                  <th class="text-end">{{ paid }}</th>
                  <th class="text-end">{{ left }}</th>
                  <th *ngIf="userHasAccess">{{ invoice }}</th>
                  <th *ngIf="userHasAccess" class="text-center">{{ actions }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let order of monthGroup.orders">

                  <!-- Adjustment row (readonly admin override) -->
                  <tr *ngIf="isAdjustment(order)" class="adjustment-row bg-accent-50/60 border-r-4 border-accent-500">
                    <td>
                      <div class="flex flex-col">
                        <span>{{ order.createdAt | date : 'd בMMM' : '' : 'he-IL' }}</span>
                        <small class="text-ink-500">{{ order.createdAt | date : 'HH:mm' }}</small>
                      </div>
                    </td>
                    <td colspan="5">
                      <div class="flex flex-col gap-1">
                        <span class="inline-flex items-center gap-2 text-base font-bold text-accent-700">
                          <i class="material-symbols-outlined text-lg" aria-hidden="true">tune</i>
                          התאמת יתרה ידנית
                          <span class="money font-bold"
                                [class.money--credit]="order.pricePaid > order.price"
                                [class.money--debt]="order.price > order.pricePaid">
                            {{ order.pricePaid > order.price ? '+' : '−' }}{{ (order.pricePaid > order.price ? order.pricePaid - order.price : order.price - order.pricePaid) | currency : 'ILS' : 'symbol' : '1.0-0' }}
                          </span>
                        </span>
                        <span class="text-sm text-ink-600">
                          בוצע ע"י <span class="font-semibold">{{ order.doneBy || 'אדמין' }}</span>
                          <ng-container *ngIf="order.note">
                            · סיבה: <span class="italic">{{ order.note }}</span>
                          </ng-container>
                        </span>
                      </div>
                    </td>
                    <td *ngIf="userHasAccess"></td>
                    <td *ngIf="userHasAccess" class="text-center">
                      <span class="text-xs text-ink-500 italic">לקריאה בלבד</span>
                    </td>
                  </tr>

                  <!-- Regular order row -->
                  <tr
                    *ngIf="!isAdjustment(order)"
                    class="order-row cursor-pointer"
                    [routerLink]="['/prayers/overall-table', userId, 'order', order._id]"
                  >
                    <td>
                      <div class="flex flex-col">
                        <span>{{ order.createdAt | date : 'd בMMM' : '' : 'he-IL' }}</span>
                        <small class="text-ink-500">{{ order.createdAt | date : 'HH:mm' }}</small>
                      </div>
                    </td>
                    <td class="font-semibold">{{ order.parasha }}</td>
                    <td class="text-sm text-ink-700">
                      <ng-container *ngIf="order.name?.length; else noName">
                        <span *ngFor="let n of order.name; let last = last">
                          {{ n }}<ng-container *ngIf="!last">, </ng-container>
                        </span>
                      </ng-container>
                      <ng-template #noName>
                        <span class="text-ink-400">—</span>
                      </ng-template>
                    </td>
                    <td class="text-end money">
                      {{ order.price | currency : 'ILS' : 'symbol' : '1.0-0' }}
                    </td>
                    <td class="text-end money">
                      {{ order.pricePaid | currency : 'ILS' : 'symbol' : '1.0-0' }}
                    </td>
                    <td class="text-end">
                      <ng-container *ngIf="order.pricePaid >= order.price; else hasRemaining">
                        <span class="inline-flex items-center gap-1 text-success font-semibold">
                          <i class="material-symbols-outlined text-base" aria-hidden="true">check_circle</i>
                          שולם
                        </span>
                      </ng-container>
                      <ng-template #hasRemaining>
                        <span class="money money--debt font-semibold">
                          {{ order.price - order.pricePaid | currency : 'ILS' : 'symbol' : '1.0-0' }}
                        </span>
                      </ng-template>
                    </td>

                    <!-- Invoice (inline editable for admins) -->
                    <td *ngIf="userHasAccess" (click)="$event.stopPropagation()">
                      <input
                        type="text"
                        [value]="order.orderInvoice || ''"
                        placeholder="מס' קבלה"
                        class="input-2026 text-base"
                        (input)="onInputChange($event, order._id)"
                        aria-label="מס' קבלה"
                      />
                    </td>

                    <!-- Actions -->
                    <td *ngIf="userHasAccess" class="text-center" (click)="$event.stopPropagation()">
                      <div class="flex items-center justify-center gap-2">
                        <button
                          *ngIf="showEditButton === order._id"
                          type="button"
                          class="btn-2026--primary !min-h-[40px] !py-1 !px-3 !text-base"
                          (click)="saveInvoice(order._id)"
                          aria-label="שמור מספר קבלה"
                        >
                          <i class="material-symbols-outlined" aria-hidden="true">save</i>
                        </button>
                        <button
                          type="button"
                          class="btn-2026--danger !min-h-[40px] !py-1 !px-3 !text-base"
                          (click)="openDeleteModal(order._id)"
                          aria-label="מחק הזמנה"
                        >
                          <i class="material-symbols-outlined" aria-hidden="true">delete</i>
                        </button>
                      </div>
                      <app-confirm-dialog
                        #confirmDialog
                        [action]="deleteAction"
                        [loading]="loading"
                      ></app-confirm-dialog>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- ── Pagination controls ─────────────────────────────────── -->
      <nav *ngIf="totalPages > 1" class="pagination-nav card-2026 flex items-center justify-between gap-3 flex-wrap" aria-label="ניווט בין עמודים">
        <button
          type="button"
          class="btn-2026--ghost"
          (click)="prevPage()"
          [disabled]="currentPage === 1"
        >
          <i class="material-symbols-outlined" aria-hidden="true">chevron_right</i>
          הקודם
        </button>

        <div class="flex items-center gap-2 text-base text-ink-600">
          <span>עמוד</span>
          <span class="font-bold text-ink-800">{{ currentPage }}</span>
          <span>מתוך</span>
          <span class="font-bold text-ink-800">{{ totalPages }}</span>
        </div>

        <button
          type="button"
          class="btn-2026--ghost"
          (click)="nextPage()"
          [disabled]="currentPage === totalPages"
        >
          הבא
          <i class="material-symbols-outlined" aria-hidden="true">chevron_left</i>
        </button>
      </nav>
    </ng-container>

    <ng-template #noOrders>
      <div class="card-2026 text-center py-12">
        <i class="material-symbols-outlined text-5xl text-ink-300 mb-2" aria-hidden="true">receipt_long</i>
        <h2 class="text-xl font-semibold text-ink-700">
          <ng-container *ngIf="hasFilters; else noneAtAll">אין הזמנות התואמות את הסינון</ng-container>
          <ng-template #noneAtAll>אין עדיין הזמנות למתפלל זה</ng-template>
        </h2>
        <p class="text-base text-ink-500 mt-1">
          <ng-container *ngIf="hasFilters">נסה לנקות את הסינון</ng-container>
          <ng-container *ngIf="!hasFilters">הזן הזמנה ראשונה כדי שתופיע כאן</ng-container>
        </p>
        <button *ngIf="hasFilters" type="button" (click)="resetFilters()" class="btn-2026--ghost mt-4 inline-flex">
          <i class="material-symbols-outlined" aria-hidden="true">close</i>
          נקה סינון
        </button>
      </div>
    </ng-template>

  </ng-container>

  <ng-template #loadingState>
    <div class="card-2026 space-y-4">
      <div class="skeleton-2026 h-16 w-2/3"></div>
      <div class="skeleton-2026 h-8 w-1/2"></div>
      <div class="skeleton-2026 h-12 w-full mt-6"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
    </div>
  </ng-template>

  <!-- ── Hidden compact print view (for full-history PDF) ────────────
       Lives off-screen at left:-9999px so it has real box measurements
       for html2canvas-pro but never appears in the visible UI. Every
       order is rendered — filters, pagination and year/month grouping
       are all ignored here. The layout targets A4 portrait (200mm) and
       uses three tight sub-columns to fit as many rows as possible per
       page while staying readable. -->
  <div
    #fullHistoryPrint
    *ngIf="user"
    class="full-history-print"
    aria-hidden="true"
  >
    <div class="full-history-print__header">
      <div class="full-history-print__title">
        <div class="full-history-print__eyebrow">היסטוריית הזמנות מלאה</div>
        <div class="full-history-print__name">
          {{ user.firstName }} {{ user.lastName }}
        </div>
      </div>
      <div class="full-history-print__stats">
        <div class="full-history-print__stat">
          <span class="full-history-print__stat-label">סה"כ הזמנות</span>
          <span class="full-history-print__stat-value">{{ user.orders.length }}</span>
        </div>
        <div class="full-history-print__stat">
          <span class="full-history-print__stat-label">יתרה</span>
          <span
            class="full-history-print__stat-value"
            [class.credit]="user.balance > 0"
            [class.debt]="user.balance < 0"
          >
            <ng-container *ngIf="user.balance > 0">+</ng-container>{{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
          </span>
        </div>
      </div>
    </div>

    <div class="full-history-print__columns">
      <div class="full-history-print__col" *ngFor="let col of fullHistoryColumns">
        <table class="full-history-print__table">
          <thead>
            <tr>
              <th>תאריך</th>
              <th>פרשה</th>
              <th class="num">סכום</th>
              <th class="num">שולם</th>
              <th class="num">נותר</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of col" [class.adjustment]="isAdjustment(order)">
              <td>{{ order.createdAt | date : 'dd/MM/yy' }}</td>
              <td class="parasha">{{ order.parasha }}</td>
              <td class="num">{{ order.price | currency : 'ILS' : 'symbol' : '1.0-0' }}</td>
              <td class="num">{{ order.pricePaid | currency : 'ILS' : 'symbol' : '1.0-0' }}</td>
              <td class="num"
                  [class.debt]="order.price > order.pricePaid"
                  [class.credit]="order.pricePaid > order.price">
                <ng-container *ngIf="order.pricePaid >= order.price; else remaining">✓</ng-container>
                <ng-template #remaining>{{ order.price - order.pricePaid | currency : 'ILS' : 'symbol' : '1.0-0' }}</ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="full-history-print__footer">
      בית הכנסת תפארת ישראל, גני צבי · הופק ב-{{ today | date : 'd בMMM y, HH:mm' : '' : 'he-IL' }}
    </div>
  </div>

  <!-- ── Balance-adjust dialog ──────────────────────────────────── -->
  <div
    *ngIf="showAdjustDialog && user"
    class="adjust-dialog fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
    aria-labelledby="adjustDialogTitle"
    (click)="closeAdjustDialog()"
  >
    <div
      class="bg-surface rounded-2xl shadow-elevated max-w-md w-full max-h-[90vh] flex flex-col overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="p-4 bg-accent-500 text-white flex justify-between items-center gap-3">
        <h2 id="adjustDialogTitle" class="text-lg font-bold flex items-center gap-2">
          <i class="material-symbols-outlined" aria-hidden="true">tune</i>
          התאמת יתרה ידנית
        </h2>
        <button
          type="button"
          (click)="closeAdjustDialog()"
          class="p-1 hover:bg-white/20 rounded-lg transition-colors"
          aria-label="סגור"
        >
          <i class="material-symbols-outlined" aria-hidden="true">close</i>
        </button>
      </div>

      <!-- Body -->
      <div class="flex-1 overflow-y-auto p-4 space-y-4">

        <!-- Warning explanation -->
        <div class="text-sm bg-warning-soft text-ink-700 rounded-lg p-3 leading-relaxed">
          הפעולה הזו מתעדת התאמה ידנית של היתרה במתפלל
          <span class="font-bold">{{ user.firstName }} {{ user.lastName }}</span>.
          הפעולה תופיע בהיסטוריית ההזמנות עם שמך וסיבת ההתאמה, ולא ניתן יהיה למחוק
          או לערוך אותה. השתמש רק לתיקון אי־דיוקים שנוצרו בעבר.
        </div>

        <!-- Current balance -->
        <div class="flex items-center justify-between py-2 border-y border-ink-100">
          <span class="text-base text-ink-600">יתרה נוכחית</span>
          <span class="money font-bold text-lg"
                [class.money--credit]="user.balance > 0"
                [class.money--debt]="user.balance < 0"
                [class.money--zero]="user.balance === 0">
            {{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
          </span>
        </div>

        <!-- Direction picker -->
        <div class="form-row-2026">
          <label class="form-row-2026__label">סוג ההתאמה</label>
          <div class="grid grid-cols-2 gap-2">
            <button
              type="button"
              (click)="setAdjustDirection('add')"
              [attr.aria-pressed]="adjustDirection === 'add'"
              class="min-h-tap rounded-lg border-2 px-3 py-2 text-base font-semibold transition-colors flex items-center justify-center gap-2"
              [class.border-success]="adjustDirection === 'add'"
              [class.bg-success-soft]="adjustDirection === 'add'"
              [class.text-success]="adjustDirection === 'add'"
              [class.border-ink-200]="adjustDirection !== 'add'"
              [class.text-ink-600]="adjustDirection !== 'add'"
            >
              <span class="text-2xl leading-none">+</span>
              הוסף ליתרה
            </button>
            <button
              type="button"
              (click)="setAdjustDirection('subtract')"
              [attr.aria-pressed]="adjustDirection === 'subtract'"
              class="min-h-tap rounded-lg border-2 px-3 py-2 text-base font-semibold transition-colors flex items-center justify-center gap-2"
              [class.border-danger]="adjustDirection === 'subtract'"
              [class.bg-danger-soft]="adjustDirection === 'subtract'"
              [class.text-danger]="adjustDirection === 'subtract'"
              [class.border-ink-200]="adjustDirection !== 'subtract'"
              [class.text-ink-600]="adjustDirection !== 'subtract'"
            >
              <span class="text-2xl leading-none">−</span>
              הפחת מיתרה
            </button>
          </div>
        </div>

        <!-- Amount -->
        <div class="form-row-2026">
          <label class="form-row-2026__label" for="adjustAmount">סכום (₪)</label>
          <input
            id="adjustAmount"
            type="text"
            inputmode="numeric"
            autocomplete="off"
            class="input-2026 text-lg font-semibold"
            placeholder="0"
            [value]="adjustAmount ?? ''"
            (input)="onAdjustAmountInput($any($event.target).value)"
          />
        </div>

        <!-- Reason -->
        <div class="form-row-2026">
          <label class="form-row-2026__label" for="adjustReason">סיבה (אופציונלי)</label>
          <input
            id="adjustReason"
            type="text"
            class="input-2026"
            placeholder="לדוגמה: תיקון של 19→20 משבת בראשית"
            [(ngModel)]="adjustReason"
          />
        </div>

        <!-- Preview -->
        <div *ngIf="adjustPreviewBalance !== null"
             class="rounded-lg p-3 flex items-center justify-between"
             [class.bg-success-soft]="adjustDirection === 'add'"
             [class.bg-danger-soft]="adjustDirection === 'subtract'">
          <span class="text-base font-medium text-ink-700">יתרה לאחר ההתאמה</span>
          <span class="money font-bold text-lg"
                [class.money--credit]="adjustPreviewBalance > 0"
                [class.money--debt]="adjustPreviewBalance < 0"
                [class.money--zero]="adjustPreviewBalance === 0">
            {{ adjustPreviewBalance | currency : 'ILS' : 'symbol' : '1.0-0' }}
          </span>
        </div>
      </div>

      <!-- Footer -->
      <div class="p-4 border-t border-ink-100 bg-bg flex flex-col-reverse sm:flex-row sm:justify-between gap-3">
        <button type="button" (click)="closeAdjustDialog()" class="btn-2026--ghost w-full sm:flex-1">
          ביטול
        </button>
        <button
          type="button"
          (click)="submitAdjust()"
          [disabled]="!adjustAmount || adjustAmount <= 0 || adjustSubmitting"
          [class]="adjustDirection === 'subtract' ? 'btn-2026--danger w-full sm:flex-1' : 'btn-2026--primary w-full sm:flex-1'"
        >
          <span *ngIf="!adjustSubmitting" class="flex items-center gap-2 justify-center">
            <i class="material-symbols-outlined" aria-hidden="true">check_circle</i>
            אישור התאמה
          </span>
          <span *ngIf="adjustSubmitting" class="flex items-center gap-2 justify-center">
            <mat-spinner diameter="20"></mat-spinner>
            <span>מעדכן...</span>
          </span>
        </button>
      </div>
    </div>
  </div>

</section>
